import { BFFAgent } from '../../../../common/BFFAgent'
import { put, call } from 'redux-saga/effects'
import { toast } from 'react-toastify';
import { ESTADO, MESSAGE_UPDATE_STATE } from '../../constants';
import {
  COMMISSION_POLICY_STATUS_UPDATE_SUCCESS,
  COMMISSION_POLICY_STATUS_UPDATE_FAILURE,
} from '../constants'

export function* updatePolicyStatusSaga({data: { id, actionCode}}) {
  try {
    const responseUpdatePolicyStatus =  yield call(
      BFFAgent.Commission.updatePolicyStatus,
      id,
      actionCode
      )
      
      if (responseUpdatePolicyStatus) {
        let message
        switch (responseUpdatePolicyStatus.new_state.id) {
          case ESTADO.ACTIVA:
            message = MESSAGE_UPDATE_STATE.ACTIVA
            break;
          case ESTADO.CONFIRMADA:
            message = MESSAGE_UPDATE_STATE.CONFIRMADA
            break;
          case ESTADO.LIQUIDADA:
            message = MESSAGE_UPDATE_STATE.LIQUIDADA
            break;
          case ESTADO.FINALIZADA:
            message = MESSAGE_UPDATE_STATE.FINALIZADA
            break;
          default:
            message = MESSAGE_UPDATE_STATE.DEFAULT
            break;
        }
        
        toast.success(message)
        
      yield put({
          type: COMMISSION_POLICY_STATUS_UPDATE_SUCCESS,
          data: responseUpdatePolicyStatus
      })
    }
  } catch (error) {
    yield put({
      type: COMMISSION_POLICY_STATUS_UPDATE_FAILURE,
      data: { error }
    })
  }
}
